import React, { FC, memo, useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import { ElementProps } from './types';
import { Cancel } from './Cancel';

const Component: FC<ElementProps> = memo((props) => {
    const [focus, setFocus] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const onclick = () => {
        props.onRemove(props.index, focus);
    };
    useLayoutEffect(() => {
        if (ref && ref.current && props.focus) {
            ref.current.focus();
        }
    }, [props.focus]);

    const onkeydown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const { key } = event;
        event.preventDefault();
        if (key === 'Backspace' || key === 'Delete') {
            props.onRemove(props.index, props.focus);
        } else if (key === 'ArrowLeft') {
            props.onSelectedIndex(props.index - 1);
        } else if (key === 'ArrowRight') {
            props.onSelectedIndex(props.index + 1);
        }
    };
    return (
        <div
            data-testid="tag-element"
            ref={ref}
            tabIndex={0}
            className={classnames('badge bg-secondary bg-gradient me-1 pe-1 justify-content-between text-dark', props.className)}
            onKeyUp={onkeydown}
            onFocus={() => {
                setFocus(true);
            }}
            onBlur={() => {
                setFocus(false);
            }}
        >
            {props.value}
            <button
                data-testid="tag-clean-element"
                aria-label="remove path fragment"
                tabIndex={-1}
                className="border-0 rounded-circle"
                style={{ outline: 0, background: '#808080', padding: 0, width: 15, height: 15, marginLeft: 4 }}
                type="button"
                onClick={onclick}
            >
                <Cancel style={{ fill: 'var(--bs-white)', opacity: 1 }} />
            </button>
        </div>
    );
});

Component.displayName = 'Element';

export const Element: FC<ElementProps> = Object.assign(Component, {});
